import React,{useState,useEffect} from 'react';
import { Avatar } from '@material-ui/core';
import './Sidebarchat.css'; 
import { collection, addDoc } from "firebase/firestore";
import DB from './Firebase';
import { query, orderBy } from "firebase/firestore";  
import { onSnapshot, doc, serverTimestamp } from 'firebase/firestore';
import {getname} from './userSlice';
import { useDispatch,useSelector } from 'react-redux';
function Sidebarchat({ischat,id}) {
    const creatername=useSelector(getname);
    const[seed,setseed]=useState("");
    const [message,setmessage]=useState([]);
useEffect(()=>{
if(id){

    
        const q = query(collection(DB,"/wtrooms/"+id+"/wtmessages"), orderBy("timestamp","desc"));
        
        onSnapshot(q,(snap)=>{
        
        let temp=snap.docs.map((doc)=>{return {id:doc.id,...doc.data()}});
        setmessage(temp);
        })

}

},[])

useEffect(()=>{setseed(Math.floor(Math.random()*1000))},[]);
const createnewchat=()=>{

let roomname=window.prompt("Enter your Room Name ");
if(roomname){
addDoc(collection(DB,"wtrooms"),{name:roomname,creater:creatername,timestamp:serverTimestamp()});
}
}


  return  ischat ? (<div className='sidebarchat'>
      <Avatar src={`https://avatars.dicebear.com/api/jdenticon/${seed}.svg `} />
      <div className="sidebarchat_data">
          <h3>{ischat}</h3>
          <p>{message.length!==0? message[0].message:<></>}</p>
      </div></div>):
      
     ( <div onClick={()=>{createnewchat()}} className='sidebarchat'>
          <h3>Add New Chat</h3>

      </div>)
      }

export default Sidebarchat;
